const BADGE_BG = '#E53935'
const BADGE_TEXT = '#FFFFFF'

const styles = {
  anchor: {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  pill: {
    position: 'absolute',
    top: -6,
    right: -12,
    minWidth: 18,
    height: 18,
    padding: '0 5px',
    borderRadius: 12,
    background: BADGE_BG,
    color: BADGE_TEXT,
    border: `1px solid ${BADGE_TEXT}`,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none',
    boxSizing: 'border-box'
  },
  label: {
    color: BADGE_TEXT,
    fontSize: 11,
    fontWeight: 700,
    lineHeight: '11px',
    whiteSpace: 'nowrap'
  }
}

export default styles
